// SPDX-License-Identifier: MIT
/** Player scene API: functional Mini constructors/checks, without the full compiler/locales namespace.
 * Custom scenes must be rebuilt with bundleCustomScenes(..., { target: 'player' }).
 * Server rendering continues to export the full classic `z` from index.ts.
 */
export { object, string, number, boolean, array, tuple, record, literal, enum, union, discriminatedUnion, unknown, any, never, null, optional, nullable, _default, instanceof, int, gte, lte, minLength, maxLength, length, regex, positive, nonnegative, refine, superRefine, } from 'zod/mini';
